import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["activeStep", "handleStep", "steps", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Step, Stepper, StepButton, StepConnector } from '../../..';

var TAGMeatballMenu = function TAGMeatballMenu(_ref) {
  var activeStep = _ref.activeStep,
      handleStep = _ref.handleStep,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var connector = React.createElement(StepConnector, {
    sx: {
      display: 'none'
    }
  });
  return React.createElement(Stepper, _objectSpread(_objectSpread({}, props), {}, {
    nonLinear: true,
    activeStep: activeStep,
    connector: connector,
    sx: [{
      justifyContent: 'center'
    }, sx]
  }), steps.map(function (_, index) {
    return React.createElement(Step, {
      key: index,
      sx: {
        padding: '0px 4px'
      }
    }, React.createElement(StepButton, {
      disableRipple: true,
      onClick: function onClick() {
        return handleStep(index);
      },
      sx: [{
        '&.MuiStepButton-root': {
          boxSizing: 'border-box',
          padding: '0px',
          margin: '0px',
          '&:hover': {
            cursor: activeStep === index ? 'default' : ''
          }
        },
        '.MuiStepIcon-text': {
          display: 'none'
        },
        '.MuiStepLabel-iconContainer': {
          padding: '0px'
        },
        '.MuiSvgIcon-root': {
          fontSize: '8px',
          color: 'neutrals.disabled',
          '&.Mui-active': {
            color: 'secondary.main'
          },
          '&:hover': {
            color: activeStep !== index ? 'secondary.light' : '',
            border: activeStep !== index ? '2px solid' : '',
            borderColor: activeStep !== index ? 'secondary.main' : '',
            boxSizing: 'border-box',
            borderRadius: '50%'
          }
        }
      }]
    }));
  }));
};

export default TAGMeatballMenu;